export enum BorderRadius {
    OuterBlockRadius = '32px',
    InnerBlockRadius = '24px',
    componentRadius = '16px',
    labelRadius = '8px',
    alert = '50px',
}
